module.exports = "/_next/static/images/d75638b3c4202eeed7c15f1483b73eea-join-us-xs-1x.png";